





















import { defineComponent, onMounted } from '@nuxtjs/composition-api';
import type { PropType } from '@nuxtjs/composition-api';
import { loadHeurekaWidget } from '~/helpers/heureka/loadHeurekaWidget';
import { HeurekaWidgetOptions } from '~/types/components/Heureka/HeurekaWidgetOptions';
import Link from '~/components/atoms/Link/Link.vue';
import { LinkType } from '~/types/components/Link/LinkType';

export default defineComponent({
  name: 'HeurekaWidget',
  components: {
    Link,
  },
  props: {
    options: {
      type: Object as PropType<HeurekaWidgetOptions>,
      required: true,
    },
  },
  setup (props) {
    onMounted(() => {
      loadHeurekaWidget(props.options);
    });

    return {
      LinkType,
    };
  },
});
